import { Component } from '@angular/core';
import { AgGridI, paginationModel } from '../../shared/common-components/ag-grid/ag-grid.model';
import { AgGridDataModelMessagifyUser} from './Messagify.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MessagifyUserPopupComponent } from './messagify-user-popup/messagify-user-popup.component';
import { WhatsappTemplateService } from '../whatsapp-template/whatsapp-template.service';
import { MessagifyUserService } from './messagify-user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-messagify-user',
  templateUrl: './messagify-user.component.html',
  styleUrls: ['./messagify-user.component.scss']
})

export class MessagifyUserComponent {
  MessagifyUserDatamodal = new paginationModel();
  totalRecords: any;
  agGridDataModelMessagifyUser: AgGridI;
  rowData: any;

  constructor(private modalService: NgbModal,public whatsappTemplateService:WhatsappTemplateService, public  messagifyUserService : MessagifyUserService, public toastr:ToastrService) {}

  ngOnInit(): void {
    this.agGridDataModelMessagifyUser = AgGridDataModelMessagifyUser;
  }

  onGridReady(params: any) {
    this.getAll();
  }

  onChangePage(event: any) {
    this.MessagifyUserDatamodal.pageNumber = event?.pageNumber;
    this.MessagifyUserDatamodal.page = event?.pageNumber;
    this.MessagifyUserDatamodal.pageSize = event?.pageSize;
    // Match other CRM grids: pageSize === 1 means "get all" for export-style fetches
    this.MessagifyUserDatamodal.getAll = this.MessagifyUserDatamodal.pageSize === 1;
    this.getAll();
  }

  onDelete(row: any) {
  }

  getAll() {
    this.whatsappTemplateService.getAllMsgFlyUser(this.MessagifyUserDatamodal).subscribe((res: any) => {
      if (res?.isSuccess) {
        const list =
          res?.response?.getAllMsgFlyUserList ??
          res?.response?.GetAllMsgFlyUserList ??
          [];
        this.rowData = list;
        this.totalRecords = res.totalRecords ?? 0;
      } else {
        this.rowData = [];
        this.totalRecords = res?.totalRecords ?? 0;
      }
    });
  }

  createMsgifyUserPopup(params?): void {
    const copyOfObject = Object.assign({}, params?.detail?.data?.data);
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    const modalRef = this.modalService.open(MessagifyUserPopupComponent, modalOption);
    modalRef.componentInstance.rowData = copyOfObject;
    modalRef.result.then((res) => {
      if (res) {
        this.getAll();
      }
    })
  }

  onExtendRegitration(data: any) {
    const extendedDate = new Date(`${data.detail?.extendedDate}T${new Date().toTimeString().split(' ')[0]}`);
    const id = data.detail.paramsdata?.registeredUserId || data.detail.paramsdata?.id;
    const apidata = { renewalDate: extendedDate, id: id };
    this.messagifyUserService.extendMsgiflySubscription(apidata).subscribe((res) => {
      if (res?.isSuccess) {
        this.toastr.success(res.message);
        this.getAll();
      } else {
        this.toastr.error(res.message);
      }
    })
  }

}
